import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ProposalFilter from '../../../widgets/proposalFilter/ProposalFilter'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import { getSchema } from '../../../redux/actions/proposalFilterOther'
import { startLoading, doneLoading } from '../../../utils/loading'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'
import { ProposalFilterType } from '../../../constants/proposalFilter'
import AIEvaluationResultWidget from '../../../widgets/aiEvaluation/AIEvaluationResultWidget'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { getAiEvaluationResult } from '../../../redux/actions/aiEvaluation'

export default function ProposalFilterOther() {
  const [isLoading, setIsLoading] = useState(false)
  const [schema, setSchema] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [error, setError] = useState()
  const [proposalEvaluationResult, setProposalEvaluationResult] = useState()

  useEffect(() => {
    handleGetSchema()

    projectId && handleGetProposalEvaluationResult()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchema(projectId)
      setSchema(_schema.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  const handleGetProposalEvaluationResult = async () => {
    try {
      const response = await getAiEvaluationResult(projectId)
      if (response) {
        setProposalEvaluationResult(response)
      }
    } catch (e) {}
  }

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ProjectBasicInfo schema={schema.forms?.ProjectInfo} />

      <AIEvaluationResultWidget schema={proposalEvaluationResult} shaded showDetail={false} />
      <br />

      <ProposalFilter
        schema={schema.forms}
        proposalFilterType={ProposalFilterType.PROPOSAL_FILTER_OTHER}
      />
      <br />
    </SidebarProposal>
  )
}
